import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ClarityTracking = ({ userId }) => {
  const location = useLocation();

  useEffect(() => {
    if (window.clarity) {
      window.clarity("identify", userId, undefined, undefined, userId);
    } else {
      console.warn("Clarity is not initialized!");
    }
  }, [location, userId]);

  return null; 
};

export default ClarityTracking;